import { useOutletContext } from 'react-router-dom'

import { SettingsEmployeeGroupFragment } from 'generated/resources/graphql'

import EditModal from 'modules/legal_entities/components/EmployeeGroups/EditModal'
import { useOnClose } from 'modules/legal_entities/hooks/useOnClose'

const EditPage = () => {
  const { employeeGroup } = useOutletContext<{ employeeGroup: SettingsEmployeeGroupFragment }>()
  const onClose = useOnClose(employeeGroup.legalEntityId)

  return <EditModal onClose={onClose} employeeGroup={employeeGroup} />
}

export default EditPage
